module.exports = __webpack_public_path__ + "static/media/banner-img1.2e965aa4.jpg";